import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper",
  ref: "horizontalWizardRef"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mw-900px w-100" }, null, -1)
const _hoisted_3 = { class: "mw-900px w-100 ms-15" }
const _hoisted_4 = { class: "fs-1 py-5 m-10 mb-0 cardTidle" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav py-5 mt-5 d-none\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Paso 1 de 3</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Paso 2 de 3</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Paso 3 de 3</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Completed</h3></div></div>", 1)
const _hoisted_6 = {
  class: "current m-10 landingInfoText",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = {
  class: "m-10 landingInfoText",
  "data-kt-stepper-element": "content"
}
const _hoisted_8 = {
  class: "m-10 landingInfoText",
  "data-kt-stepper-element": "content"
}
const _hoisted_9 = {
  class: "m-10 landingInfoText",
  "data-kt-stepper-element": "content"
}
const _hoisted_10 = { class: "d-flex flex-stack pt-5 m-10" }
const _hoisted_11 = { class: "mr-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" })
], -1)
const _hoisted_13 = ["data-kt-indicator"]
const _hoisted_14 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 ms-2 me-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" })
], -1)
const _hoisted_16 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_18 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary botonFormSecondary"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 ms-1 me-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!
  const _component_Step4 = _resolveComponent("Step4")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.nombreActividad), 1)
    ]),
    _hoisted_5,
    _createElementVNode("form", {
      class: "mx-auto mw-900px w-100 pt-0 pb-10",
      novalidate: "",
      id: "kt_create_account_form",
      onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Step1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Step2)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Step3)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Step4)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-lg btn-light-primary me-3",
            "data-kt-stepper-action": "previous",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
          }, [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("atrasBtn")), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          (_ctx.currentStepIndex === _ctx.totalSteps - 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "submit",
                class: "btn btn-lg btn-primary me-3",
                "data-kt-stepper-action": "submit",
                "data-kt-indicator": _ctx.isPendingForm ? 'on' : null
              }, [
                (!_ctx.isPendingForm)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.$t("enviarBtn")) + " ", 1),
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPendingForm)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _createTextVNode(_toDisplayString(_ctx.$t("enviandoBtn")) + " ", 1),
                      _hoisted_17
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_13))
            : (_openBlock(), _createElementBlock("button", _hoisted_18, [
                _createTextVNode(_toDisplayString(_ctx.$t("continuarBtn")) + " ", 1),
                _hoisted_19
              ]))
        ])
      ])
    ], 32)
  ], 512))
}